import React from "react";
import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

export default function EditorialMarquee() {
  const items = [
    "Tonek i Duszek",
    "Napoleon",
    "Odwaga",
    "Ciekawość",
    "Wyobraźnia",
    "Prof. Wincent",
    "Sny",
    "Pirat Billy",
  ];
  return (
    <section
      className="relative py-16 md:py-24 border-y border-[#BAE6FD] bg-[#E0F2FE]/40 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <Marquee gradient={false} speed={38} pauseOnHover>
        <div className="flex items-center gap-16 pr-16">
          {items.map((t, i) => (
            <div key={i} className="flex items-center gap-16 pr-16">
              <span
                className={`font-display font-semibold text-[4.5rem] md:text-[7rem] lg:text-[8.5rem] leading-none ${
                  i % 2 === 0 ? "text-[#051937]" : "stroke-text"
                }`}
              >
                {t}
              </span>
              <Star size={40} className="text-[#FDE68A] fill-[#FDE68A]" />
            </div>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
